import Vue from 'vue'
import Vuex from 'vuex'

import service from './modules/service'
import auth from './modules/auth'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    service,
    auth
  }
})
